export interface HeroSlide {
  id: string;
  movieId: string;
  tagline: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "s1",
    movieId: "m1",
    tagline: "跨越星海的远征，只为解开来自深空的信号。",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20a%20lone%20spaceship%20traveling%20toward%20a%20glowing%20blue%20planet%20surrounded%20by%20warm%20orange%20nebula%20clouds%2C%20dramatic%20atmospheric%20lighting%2C%20moody%20sci-fi%20film%20still%2C%20no%20text&width=1600&height=900&seq=mp-slide-1&orientation=landscape",
  },
  {
    id: "s2",
    movieId: "m7",
    tagline: "当机械开始思考，人类该如何定义自己？",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20wide%20cityscape%20at%20dusk%20with%20a%20giant%20humanoid%20robot%20silhouette%20against%20deep%20navy%20sky%20and%20warm%20orange%20city%20lights%2C%20cinematic%20sci-fi%20atmosphere%2C%20no%20text&width=1600&height=900&seq=mp-slide-2&orientation=landscape",
  },
  {
    id: "s3",
    movieId: "m20",
    tagline: "在数据支配的城市里，寻找一段不存在的记忆。",
    image: "https://readdy.ai/api/search-image?query=Neon%20cyberpunk%20megacity%20street%20at%20night%20seen%20from%20above%2C%20deep%20blue%20haze%20with%20vivid%20orange%20and%20magenta%20neon%20signs%2C%20cinematic%20futuristic%20mood%2C%20no%20text&width=1600&height=900&seq=mp-slide-3&orientation=landscape",
  },
  {
    id: "s4",
    movieId: "m23",
    tagline: "帝国的最后十年，一个君主的漫长黄昏。",
    image: "https://readdy.ai/api/search-image?query=Grand%20historic%20stone%20throne%20hall%20of%20an%20empire%20at%20sunset%2C%20deep%20blue%20shadows%20with%20warm%20orange%20light%20beams%20through%20tall%20windows%2C%20epic%20cinematic%20tone%2C%20no%20text&width=1600&height=900&seq=mp-slide-4&orientation=landscape",
  },
];